module.exports = __webpack_public_path__ + "img/upload_team.1a289cf7.png";